var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeekly105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31 8.5C31 8.22386 30.7761 8 30.5 8C30.2239 8 30 8.22386 30 8.5V16H18.5C13.8056 16 10 19.8056 10 24.5V38.5V86.5C10 91.1944 13.8056 95 18.5 95H86.5C91.1944 95 95 91.1944 95 86.5V38.5V24.5C95 19.8056 91.1944 16 86.5 16H75V8.5C75 8.22386 74.7761 8 74.5 8C74.2239 8 74 8.22386 74 8.5V16H31V8.5ZM94 38V24.5C94 20.3579 90.6421 17 86.5 17H75V26.5C75 26.7761 74.7761 27 74.5 27C74.2239 27 74 26.7761 74 26.5V17H31V26.5C31 26.7761 30.7761 27 30.5 27C30.2239 27 30 26.7761 30 26.5V17H18.5C14.3579 17 11 20.3579 11 24.5V38H94ZM11 39H94V86.5C94 90.6421 90.6421 94 86.5 94H18.5C14.3579 94 11 90.6421 11 86.5V39Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.5 50C40.7761 50 41 50.2239 41 50.5V66H64V50.5C64 50.2239 64.2239 50 64.5 50C64.7761 50 65 50.2239 65 50.5V66H82.5C82.7761 66 83 66.2239 83 66.5C83 66.7761 82.7761 67 82.5 67H65V82.5C65 82.7761 64.7761 83 64.5 83C64.2239 83 64 82.7761 64 82.5V67H41V82.5C41 82.7761 40.7761 83 40.5 83C40.2239 83 40 82.7761 40 82.5V67H22.5C22.2239 67 22 66.7761 22 66.5C22 66.2239 22.2239 66 22.5 66H40V50.5C40 50.2239 40.2239 50 40.5 50Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgWeekly105;